/**
 * `DialogContent` sizing for PDF previews: a tall dialog with narrow side gutters on mobile so pages
 * get most of the screen width, and a letter-proportioned dialog from `sm` up.
 */
export const pdfPreviewDialogClassName =
  "max-w-none w-[calc(100%-1.5rem)] h-[85dvh] p-3 gap-3 sm:w-[90vw] sm:max-w-[800px] sm:h-[90vh] sm:p-6 sm:gap-4";
